import { validationCode } from "../config/validationCode";

export const generateCode = (data) => {
  return validationCode.generateCodeFunction(data).then(response => response)
};

export const validateCodeConsult = (code) => {
  return validationCode.validateCodeFunction(code).then(response => response)
};
